// Shared helpers for activity-success evaluators.
// Pure CommonJS, no browser globals.

'use strict';

function getBlockType (block) {
    if (!block || typeof block !== 'object') {
        return null;
    }
    return block.block || block.blocktype || null;
}

// Accepts either:
//   - flat array of block objects ({block|blocktype, arg?, body?})
//   - array of script objects ({trigger?, blocks?, terminator?})
// Returns a flat array of all blocks (incl. nested repeat bodies).
function flattenBlocks (value) {
    const out = [];
    if (!Array.isArray(value)) {
        return out;
    }
    for (let i = 0; i < value.length; i += 1) {
        collect(value[i], out);
    }
    return out;
}

function collect (item, out) {
    if (!item || typeof item !== 'object') {
        return;
    }
    if (item.trigger || item.terminator || Array.isArray(item.blocks)) {
        if (item.trigger) {
            collect(item.trigger, out);
        }
        if (Array.isArray(item.blocks)) {
            for (let i = 0; i < item.blocks.length; i += 1) {
                collect(item.blocks[i], out);
            }
        }
        if (item.terminator) {
            collect(item.terminator, out);
        }
        return;
    }
    if (getBlockType(item)) {
        out.push(item);
        if (Array.isArray(item.body)) {
            for (let i = 0; i < item.body.length; i += 1) {
                collect(item.body[i], out);
            }
        }
    }
}

function roleBlocks (simState, role) {
    const scripts = simState && simState.scripts;
    if (!scripts || typeof scripts !== 'object') {
        return [];
    }
    return flattenBlocks(scripts[role]);
}

function roleHasBlock (simState, role, blockType) {
    const blocks = roleBlocks(simState, role);
    for (let i = 0; i < blocks.length; i += 1) {
        if (getBlockType(blocks[i]) === blockType) {
            return true;
        }
    }
    return false;
}

function roleHasAnyBlock (simState, role, blockTypes) {
    const blocks = roleBlocks(simState, role);
    for (let i = 0; i < blocks.length; i += 1) {
        if (blockTypes.indexOf(getBlockType(blocks[i])) > -1) {
            return true;
        }
    }
    return false;
}

// For phase-machine activities, the program is "done" when either
// phaseFlags.completed is set or the last runTrace entry is terminal.
function reachedTerminalState (simState) {
    if (!simState || typeof simState !== 'object') {
        return false;
    }
    if (simState.phaseFlags && simState.phaseFlags.completed) {
        return true;
    }
    const trace = simState.runTrace;
    if (!Array.isArray(trace) || trace.length === 0) {
        return false;
    }
    const last = trace[trace.length - 1];
    if (!last || typeof last !== 'object') {
        return false;
    }
    return Boolean(last.terminal || last.complete || last.completed);
}

function totalBlockCount (simState) {
    const scripts = simState && simState.scripts;
    if (!scripts || typeof scripts !== 'object') {
        return 0;
    }
    let count = 0;
    const roles = Object.keys(scripts);
    for (let i = 0; i < roles.length; i += 1) {
        count += flattenBlocks(scripts[roles[i]]).length;
    }
    return count;
}

module.exports = {
    getBlockType,
    flattenBlocks,
    roleBlocks,
    roleHasBlock,
    roleHasAnyBlock,
    reachedTerminalState,
    totalBlockCount
};
